import {
  Box,
  Button,
  Hidden,
  List,
  ListItem,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { getWindowDimension } from "utils/responsiveUtils";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CreateAccount from "./CreateAccount";
import UserDetails from "./UserDetails";
import Drive from "./Drive";
import Calender from "./Calender";
import CaseManager from "./CaseManagerSideBar";
import Arbitrator from "./ADRP";
import GeneralOverview from "./GeneralOverview";
import instance from "api/globalaxios";
import Finances from "Admin/Sebi/Finances";
import CreateMeeting from "Admin/SuperAdmin/CreateMeeting";
import CreateSebiDispute from "Admin/SuperAdmin/CreateSebiDispute";
import InvoiceList from "Admin/Common/InvoiceList";
import Mediator from "./Mediator";
import { isMSME, isSebi } from "Routes/Routes";
import { VENDOR } from "app/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    minHeight: "95vh",
    // height: "100%",
    borderRadius: "1rem",
    // flexDirection: (props) => (props.smallScreen ? "column" : "row"),
  },
  sidebar: {
    background: "#2C2C2C",
    width: "23rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  sidebarItem: {
    //#A4A6B3;
    fontSize: "16px",
    padding: "0.5rem 4rem",
    color: "#A4A6B3",
    letterSpacing: "0.2px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      padding: "0.5rem 2.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      padding: "0.4rem 0 0.4rem 3rem",
    },
  },
  selected: {
    backgroundColor: "rgba(159, 162, 180, 0.08)",
    // opacity: 0.08,
    // color:"#FFFFFF",
    borderLeft: "2px solid #FFFFFF;",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "0",
    overflow: "hidden",
    width: "100%",
    textAlign: "center",
  },
  body2: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "0",
    overflow: "hidden",
    width: "100%",
    textAlign: "center",
  },
}));

export default function SebiAdmin({ profile }) {
  const classes = useStyles();
  const history = useHistory();

  const ls = sessionStorage.getItem("tiac_sidebar_step");
  const mb = sessionStorage.getItem("tiac_sidebar_mobilestep");

  const [step, setStep] = useState(mb ? mb : 0);

  const removeSessionStorage = () => {
    sessionStorage.clear();
  };

  // Vendors only ever see the Invoices tab.
  const isVendor = isSebi && profile?.profile_type === VENDOR;

  const [selected, setSelected] = useState(
    isVendor
      ? 12
      : ls
      ? parseInt(ls)
      : getWindowDimension().width < 960
      ? 0
      : 1
  );

  // const [registeredDisputesList, setregisteredDisputesList] = useState({});

  // async function getDisputes() {
  //   return await instance.get("/tiac_admin_disputes/");
  // }
  // useEffect(() => {
  //   getDisputes().then((res) => {
  //     setregisteredDisputesList([
  //       ...res.data["Conciliation"],
  //       ...res.data["Arbitration"],
  //       ...res.data["closed"],
  //     ]);
  //   });
  // }, []);

  const RenderOptions = () => {
    if (isVendor) {
      return <InvoiceList profile={profile} showPaymentDetails isVendor />;
    }
    if (selected === 1 || selected === 0) {
      return <GeneralOverview profile={profile} />;
    }
    if (selected === 2) {
      return <CreateAccount profile={profile} />;
    }
    if (selected === 3) {
      return <UserDetails profile={profile} profileType={'general_rv'} />;
    }
    if (selected === 4) {
      return (
        <Finances
          profile={profile}
          // registeredDisputesList={registeredDisputesList}
          // getDisputes={getDisputes}
        />
      );
    }
    if (selected === 5) {
      return <CaseManager profile={profile} />;
    }
    if (selected === 6) {
      return <Arbitrator profile={profile} />;
    }
    if (selected === 8) {
      return <Drive profile={profile} />;
    }
    if (selected === 9) {
      return <Calender profile={profile} />;
    }
    if (selected === 10) {
      return <CreateMeeting profile={profile} />;
    }
    if (selected === 11) {
      return <CreateSebiDispute profile={profile} />;
    }
    if (selected === 12) {
      return <InvoiceList profile={profile} showPaymentDetails={isSebi} />;
    }
    if (selected === 13) {
      return <Mediator profile={profile} />;
    }
    if (selected === 14) {
      return <UserDetails profile={profile} profileType={'lawyer_rv'} />;
    }
  };

  const VendorSidebar = () => {
    return (
      <Box className={classes.sidebar}>
        <Box height="1rem" />
        <Typography
          style={{
            padding: "15px 20px 30px 20px",
            fontSize: "18px",
            color: "rgba(238, 238, 238, 0.7)",
            fontWeight: "bold",
          }}
        >
          Dashboard
        </Typography>
        <List style={{ paddingTop: "0" }}>
          <ListItem
            className={classes.selected}
            button
            onClick={() => {
              setSelected(12);
              setStep(1);
            }}
          >
            <Typography
              className={classes.sidebarItem}
              style={{ color: "#FFFFFF" }}
            >
              Invoices
            </Typography>
          </ListItem>
        </List>
      </Box>
    );
  };

  const Sidebar = () => {
    if (isVendor) {
      return <VendorSidebar />;
    }
    return (
      <Box className={classes.sidebar}>
        <Box height="1rem" />
        <Typography
          style={{
            padding: "15px 20px 30px 20px",
            fontSize: "18px",
            color: "rgba(238, 238, 238, 0.7)",
            fontWeight: "bold",
          }}
        >
          Dashboard
        </Typography>

        <List style={{ paddingTop: "0" }}>
          {selected === 1 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(1);
                setStep(1);
                removeSessionStorage();
                history.push("/");
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Overview
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(1);
                setStep(1);
                // history.push('/')
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                sessionStorage.setItem("tiac_sidebar_step", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>Overview</Typography>
            </ListItem>
          )}
          {selected === 2 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(2);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Create Accounts
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(2);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 2);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Create Accounts
              </Typography>
            </ListItem>
          )}
          {selected === 3 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(3);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                User Details
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(3);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 3);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                User Details
              </Typography>
            </ListItem>
          )}
          {isMSME ? (
            selected === 14 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(14);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Counsels
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(14);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 14);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>
                  Counsels
                </Typography>
              </ListItem>
            )
          ) : ( null )}
          {isSebi ? (
            selected === 4 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(4);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Finances
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(4);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 4);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>Finances</Typography>
              </ListItem>
            )
          ) : ( null )}
          {profile.profile_type === "sub_admin_tiac_rv" &&
            (selected === 5 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(5);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Case Managers
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(5);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 5);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>
                  Case Managers
                </Typography>
              </ListItem>
            ))}

          {selected === 6 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(6);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Arbitrators
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(6);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 6);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Arbitrators
              </Typography>
            </ListItem>
          )}
          {selected === 13 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(13);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Conciliators
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(13);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 13);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Conciliators
              </Typography>
            </ListItem>
          )}
          {/* {selected == 7 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(7);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Create Dispute
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(7);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 6);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>
                  Create Dispute
                </Typography>
              </ListItem>
            )} */}
          {isSebi ? (
            selected === 8 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(8);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Drive
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(8);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 8);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>Drive</Typography>
              </ListItem>
            )
          ) : ( null)}
          {isSebi ? (
            selected === 9 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(9);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Calendar
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(9);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 9);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>Calendar</Typography>
              </ListItem>
            )
          ) : ( null )}
          {selected === 10 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(10);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Create Meeting
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(10);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 10);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Create Meeting
              </Typography>
            </ListItem>
          )}
          {(isSebi && (profile.profile_type === "sub_admin_tiac_rv")) ? (
            selected === 11 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(11);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Create Sebi Dispute
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(11);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 11);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>
                  Create Sebi Dispute
                </Typography>
              </ListItem>
            )
          ) : null}
          {isSebi ? (
            selected === 12 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(12);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Invoices
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(12);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 12);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>Invoices</Typography>
              </ListItem>
            )
          ) : (
            null
          )}
        </List>
      </Box>
    );
  };

  const Body = () => {
    return (
      <Box className={classes.body2}>
        <Hidden mdUp>
          <Paper
            style={{
              background: "none",
              border: "none",
              boxShadow: "none",
              display: "flex",
              justifyContent: "flex-start",
              padding: "15px 20px",
            }}
          >
            <Button
              size="large"
              onClick={(e) => {
                setStep(0);
                setSelected(0);
                removeSessionStorage();
              }}
              startIcon={<ArrowBackIosIcon />}
            >
              <FormattedMessage id="buttons.back" />
            </Button>
          </Paper>
        </Hidden>
        <Box className={classes.body}>
          <RenderOptions />
        </Box>
      </Box>
    );
  };

  const MobileView = ({ step }) => {
    switch (step) {
      case 0:
      case "0":
        return <Sidebar />;
      case 1:
      case "1":
        return <Body />;
      default:
        return null;
    }
  };

  return (
    <Box className={classes.root}>
      <Hidden smDown>
        <>
          <Sidebar />
          <Body />
        </>
      </Hidden>
      <Hidden mdUp>
        <MobileView step={step} />
      </Hidden>
    </Box>
  );
}
